
import { of as observableOf,  Observable } from 'rxjs'
import { V1 } from './net'
import { StoreThunkDispatch } from 'store/state'

export function searchTeamMembers(emails: string[] = [], userIds: string[] = [], appIds: string[] = []) {
  return (dispatch: StoreThunkDispatch) => {
    if (emails.length + userIds.length + appIds.length === 0) {
      return observableOf([])
    }
    return dispatch(V1.searchTeamMembers(emails, userIds, appIds))
  }
}

export function switchChargifyAccounts(ids: string[]) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.switchChargifyAccounts(ids))
  }
}
